import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ── PWA Service Worker ────────────────────────────────────────────────────
if ('serviceWorker' in navigator && process.env.REACT_APP_ENV !== 'development') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => console.log('[SW] Registered:', reg.scope))
      .catch(err => console.log('[SW] Registration failed:', err));
    // FCM messaging service worker
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .catch(() => {}); // non-blocking
  });
}
